(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-book-card"] && !Shopify.designMode) return;
  try {
    (() => {
 const align = grid => {
  const cards = [...grid.querySelectorAll(':scope > .sc-discovery__card')].filter(card => !card.hidden);
  cards.forEach(card => ['title','price','formats'].forEach(part => card.style.removeProperty(`--sc-${part}-height`)));
  const rows = new Map();
  cards.forEach(card => { const top = Math.round(card.offsetTop); if (!rows.has(top)) rows.set(top, []); rows.get(top).push(card); });
  rows.forEach(row => {
   ['title','price','formats'].forEach((part,index) => {
    const selector = ['h3','.sc-discovery__price','.sc-discovery__formats'][index];
    const height = Math.ceil(Math.max(...row.map(card => card.querySelector(selector).getBoundingClientRect().height)));
    row.forEach(card => card.style.setProperty(`--sc-${part}-height`, `${height}px`));
   });
  });
 };
 const setup = () => document.querySelectorAll('.sc-discovery__grid').forEach(grid => {
  if (grid.dataset.alignmentReady) return;
  grid.dataset.alignmentReady = 'true';
  let width = 0;
  new ResizeObserver(entries => { const next = entries[0].contentRect.width; if (next !== width) { width = next; align(grid); } }).observe(grid);
  document.fonts.ready.then(() => align(grid));
 });
 document.addEventListener('sc:recommendations-ready', event => { setup(); align(event.target.querySelector('.sc-discovery__grid')); });
 document.addEventListener('sc:catalog-filter', event => { const grid = event.target.querySelector('.sc-discovery__grid'); if (grid) align(grid); });
 document.addEventListener('shopify:section:load', setup);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-book-discovery"] && !Shopify.designMode) return;
  try {
    (() => {
 const setup = () => document.querySelectorAll('[data-book-discovery]').forEach(section => {
  if (section.dataset.rotationReady) return;
  section.dataset.rotationReady = 'true';
  const current = section.dataset.currentBook, category = section.dataset.currentCategory, best = section.dataset.bestBook;
  const pool = [...section.querySelector('template').content.querySelectorAll('[data-discovery-book]')];
  let visit = 0;
  try { const key = `sc-book-visit:${current}`; visit = Number(sessionStorage.getItem(key) || 0); sessionStorage.setItem(key, String(visit + 1)); } catch {}
  const seed = [...current].reduce((value, char) => ((value * 31 + char.charCodeAt(0)) >>> 0), 0);
  const rotate = (items, offset) => items.length ? [...items.slice(offset % items.length), ...items.slice(0, offset % items.length)] : [];
  const shuffle = (items, initial) => {
   const result = [...items]; let state = initial;
   for (let i = result.length - 1; i > 0; i--) { state = (Math.imul(1664525, state) + 1013904223) >>> 0; const j = state % (i + 1); [result[i], result[j]] = [result[j], result[i]]; }
   return result;
  };
  const categories = category.split('|');
  const isSame = card => card.dataset.bookCategory.split('|').some(value => categories.includes(value));
  const same = rotate(shuffle(pool.filter(isSame), seed), visit);
  const other = rotate(shuffle(pool.filter(card => !isSame(card) && card.dataset.discoveryBook !== best), seed ^ 0x9e3779b9), visit);
  const selected = same.slice(0,2);
  const winner = pool.find(card => card.dataset.discoveryBook === best);
  if (winner && !selected.includes(winner)) selected.push(winner);
  for (const card of other) { if (selected.length >= 4) break; selected.push(card); }
  for (const card of same.slice(2)) { if (selected.length >= 4) break; if (!selected.includes(card)) selected.push(card); }
  selected.sort((a,b) => Number(isSame(b)) - Number(isSame(a)));
  section.querySelector('.sc-discovery__grid').replaceChildren(...selected.map(card => card.cloneNode(true)));
  section.dispatchEvent(new CustomEvent('sc:recommendations-ready', {bubbles:true}));
 });
 document.addEventListener('shopify:section:load', setup);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-store-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{document.querySelectorAll('[data-store-nav][open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;});});
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;document.querySelectorAll('[data-store-nav][open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

})();
